import React from 'react';
import { EntityId } from "@reduxjs/toolkit";
import { useAppDispatch, useAppSelector } from "../../../../store/hooks";
import {destroyYoutubeVideo, updateYoutubeVideo} from "../../../../actions/mine_craft/youtubeVideosActions";
import {
  selectYoutubeVideoEntities,
  selectYoutubeVideoIds,
  setEditId,
  YoutubeVideoInterface
} from "../../../../store/mine_craft/youtubeVideosSlice";
import usePermissions from "../../../../hooks/usePermissions";

import { message, Spin } from "antd";
import CardImage from "../../../../componets/CardImage";
import Pagination from '../../../../componets/Pagination';
import {Button, ButtonDestroy, ButtonEdit} from "../../../../componets/Buttons";
import { TagFilled, TagOutlined } from "@ant-design/icons";

interface propsInterface {
  limit: number;
}

const _List = ({ limit }: propsInterface) => {
  const dispatch      = useAppDispatch();
  const ids           = useAppSelector(selectYoutubeVideoIds);
  const youtubeVideos = useAppSelector(selectYoutubeVideoEntities);
  const count         = useAppSelector(state => state.mineCraft.youtubeVideos.count);
  const error         = useAppSelector(state => state.mineCraft.youtubeVideos.error);
  const status        = useAppSelector(state => state.mineCraft.youtubeVideos.status);
  const { write_minecraft } = usePermissions();

  function onClickEdit(id: EntityId) {
    dispatch(setEditId(id));
  }

  function onClickDestroy(id: EntityId) {
    handleDestroy(id).catch(console.error);
  }

  async function handleDestroy (id: any) {
    const resultAction = await dispatch(destroyYoutubeVideo(id));

    if (destroyYoutubeVideo.fulfilled.match(resultAction)) {
      message.success(`ItemID ${id} was successful deleted`);
    }

    if (destroyYoutubeVideo.rejected.match(resultAction)) {
      message.error(resultAction.error.message);
    }
  }

  function toggleNew(youtubeVideo: YoutubeVideoInterface ) {
    dispatch(updateYoutubeVideo({ id: youtubeVideo.id, data: { is_new: !youtubeVideo.is_new } }));
  }

  const ToggleNewButton = ({ youtubeVideo }: { youtubeVideo: YoutubeVideoInterface }) => {
    if (youtubeVideo.is_new) {
      return <Button icon={TagOutlined} title='Remove new' onClick={() => toggleNew(youtubeVideo)} />
    } else {
      return <Button icon={TagFilled} title='Set new' onClick={() => toggleNew(youtubeVideo)} />
    }
  }

  const renderYoutubeVideo = (id: EntityId) => {
    let ribbon: any;
    const youtubeVideo = youtubeVideos[id];

    if (!youtubeVideo) {
      return;
    }

    if (youtubeVideo.is_new) {
      ribbon = {
        color: 'volcano',
        placement: 'start',
        text: 'new'
      };
    }

    return (
      <CardImage
        key={youtubeVideo.id}
        image={youtubeVideo.preview_url}
        link={youtubeVideo.url}
        title={youtubeVideo.title}
        ribbon={ribbon}
        options={write_minecraft ? [
          <ButtonEdit key={`edit-${youtubeVideo.id}`} onClick={() => onClickEdit(youtubeVideo.id)} />,
          <ButtonDestroy key={`destroy-${youtubeVideo.id}`} onClick={() => onClickDestroy(youtubeVideo.id)} />,
          <ToggleNewButton key={`new-${youtubeVideo.id}`} youtubeVideo={youtubeVideo} />
        ] : []}
      />
    )
  }

  if (status === 'loading') {
    return <Spin/>;
  }

  if (status === 'failed') {
    return <div>Error: {error}</div>
  }

  return (
    <>
      {ids && ids.map(renderYoutubeVideo)}

      <Pagination total={count} size={limit} />
    </>
  );
}

export default _List;
